import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { timeFormatter } from '../../utils/formatters.utils';

interface IProps {
  duration: number;
}

export const QuestionDuration:React.FC<IProps> = ({ duration }) => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget__question-duration myinterview-text--S">
      <Text size="S-Regular" color="neutral-40">{duration ? timeFormatter(duration) : t('time.unlimited')}</Text>
    </div>
  );
};
